import React from 'react';
import TemplatePicker from '../../templates/TemplatePicker';
import VetRecButton from '../../common/VetRecButton';
import { Spinner } from '../../../utils/Spinner';
import { SparklesIcon } from '@heroicons/react/24/solid';
import { TemplateType } from '@neum/frontend-shared/constants/templateData';
import { TemplateObject } from '../../../utils/TemplateObject';

interface DocumentActionPromptBannerProps {
    title?: string
    description?: string
    templateType?: TemplateType
    template?: TemplateObject
    setTemplate?: (value: TemplateObject | undefined) => void
    templateIdForce?: string
    externalTemplateId?: string
    buttonText: string
    onButtonClick: () => Promise<void>
    hideTemplatePicker?: boolean
    className?: string
}

export const DocumentActionPromptBanner: React.FC<DocumentActionPromptBannerProps> = ({
    title,
    description,
    templateType,
    template,
    setTemplate,
    templateIdForce,
    externalTemplateId,
    buttonText,
    onButtonClick,
    hideTemplatePicker = false,
    className = "",
}: DocumentActionPromptBannerProps) => {
    return (
        <div className={`bg-blue-100 sm:rounded-lg px-4 py-5 sm:p-6 xl:flex xl:flex-row justify-between items-center align-middle ${className}`}>
            <div className="flex items-center">
                <div>
                    <h3 className="text-base font-semibold leading-6 text-gray-900">{title}</h3>
                    {description && <div className="mt-2 max-w-xl text-sm text-gray-500">
                        <p>{description}</p>
                    </div>}
                </div>
            </div>
            <div className="xl:mt-0 flex flex-col sm:flex-row md:items-center gap-x-4 gap-y-4">
                {!hideTemplatePicker && <TemplatePicker 
                    template={template} 
                    templateIdForce={templateIdForce} 
                    setTemplate={setTemplate} 
                    className="h-10" 
                    templateBackground='bg-[linear-gradient(to_bottom,#dbeafe_50%,white_50%)]' 
                    type={templateType} 
                    externalTemplateId={externalTemplateId}
                />}
                <VetRecButton
                    type="button"
                    className="inline-flex items-center gap-x-2 rounded-md bg-main-button px-3.5 py-2.5 text-sm font-semibold text-main-button-text shadow-sm hover:bg-main-button-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 h-10 overflow-hidden xl:w-36 lg:w-36 md:w-36 sm:w-36 w-full justify-center"
                    onClick={onButtonClick}
                    disabled={!hideTemplatePicker && !template}
                >
                    {!hideTemplatePicker && !template && <Spinner size="h-5 w-5" timer={false}/>}
                    {(hideTemplatePicker || template) && <div>{buttonText}</div>}
                    {(hideTemplatePicker || template) && <SparklesIcon className="-mr-0.5 h-5 w-5" aria-hidden="true" />}
                </VetRecButton>
            </div>
        </div>
    );
};